var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("domain-workspace-toolbar", {
                attrs: {
                  uuid: _vm.currentDomainUuid,
                  backLink: _vm.backLink,
                  subtitle: "Create a Restore Job"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-card",
        { attrs: { loading: _vm.isDomainLoading } },
        [
          _c("v-card-title", [_vm._v("Create a Restore Job")]),
          _c("v-card-subtitle", [
            _c("div", { staticClass: "text-subtitle-1" }, [
              _vm._v(
                " Going through this wizard will setup a Restore job that can be run a Domain back to a previous state. "
              )
            ])
          ]),
          _c(
            "v-stepper",
            {
              staticClass: "elevation-0",
              attrs: { vertical: "" },
              model: {
                value: _vm.wizard.step,
                callback: function($$v) {
                  _vm.$set(_vm.wizard, "step", $$v)
                },
                expression: "wizard.step"
              }
            },
            [
              _c(
                "v-stepper-step",
                { attrs: { complete: _vm.wizard.step > 1, step: "1" } },
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { staticClass: "d-flex flex-nowrap" },
                            [
                              _c("div", { staticClass: "mt-1" }, [
                                _vm._v("Prepare a Restore Job")
                              ]),
                              _c(
                                "v-icon",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.havePrepared,
                                      expression: "havePrepared"
                                    }
                                  ],
                                  staticClass: "ml-2",
                                  attrs: { color: "success" }
                                },
                                [_vm._v("mdi-check-circle")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-stepper-content",
                { attrs: { step: "1" } },
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            [
                              _c(
                                "v-alert",
                                {
                                  staticClass: "mt-2 elevation-2",
                                  attrs: {
                                    border: "top",
                                    "colored-border": "",
                                    type: "warning"
                                  }
                                },
                                [
                                  _vm._v(
                                    " Restoring a domain will delete any items that are in the current Domain but are not part of the snapshot you are restoring to. Make sure that you want to actually restore the domain before proceeding. "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                attrs: {
                                  hint: _vm.inputExtractJobHint,
                                  items: _vm.selectableExportJobs,
                                  disabled:
                                    _vm.haveFetchedSourceDomain ||
                                    _vm.havePrepared,
                                  "item-text": "label",
                                  label: "Select Snapshot",
                                  "persistent-hint": "",
                                  "return-object": "",
                                  "single-line": ""
                                },
                                model: {
                                  value: _vm.inputExtractJob,
                                  callback: function($$v) {
                                    _vm.inputExtractJob = $$v
                                  },
                                  expression: "inputExtractJob"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    disabled:
                                      _vm.isPreparing || _vm.havePrepared
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.prepareJob()
                                    }
                                  }
                                },
                                [_vm._v("Prepare")]
                              ),
                              _vm.isPreparing
                                ? _c("v-progress-linear", {
                                    staticClass: "mt-4",
                                    attrs: {
                                      indeterminate: _vm.isPreparing,
                                      value: 100
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-stepper-step",
                { attrs: { complete: _vm.wizard.step > 2, step: "2" } },
                [_vm._v(" Review ")]
              ),
              _c(
                "v-stepper-content",
                { attrs: { step: "2" } },
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", [
                            _c("div", { staticClass: "ml-2 my-2" }, [
                              _vm._v(
                                " The Restore job has been successfully prepared. Go to the job's detail page to review and run it. "
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            [
                              _vm.havePrepared
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "ml-2",
                                      attrs: {
                                        color: "primary",
                                        disabled: !_vm.havePrepared
                                      },
                                      on: { click: _vm.goToLoadJobDetailPage }
                                    },
                                    [_vm._v("View Job")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }